<div class="kt-calendar w-100">
  <p-accordion>
    <p-accordionTab class="test-calendar-acordion">
      <ng-template pTemplate="header">
        <div class="d-flex w-100">
          <span class="fa fa-calendar-week pt-1"></span>
          <div class="w-100 text-center">{{ "HOME.CALENDAR" | translate }}</div>
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <ngb-datepicker *ngIf="showCalendar" #dp [(ngModel)]="model" (ngModelChange)="onDateSelect($event)"
          (navigate)="date = $event.next" [displayMonths]="displayMonths" [navigation]="navigation"></ngb-datepicker>
      </ng-template>
    </p-accordionTab>
  </p-accordion>
  <div class="calendar-bottom d-flex">
    <span class="col-sm-4 col-4" (click)="navigateRaces(yesterday)">
      {{ "HOME.YESTERDAY" | translate }}
    </span>
    <span class="col-sm-4 col-4" (click)="navigateRaces(today)"> {{ "HOME.TODAY" | translate }} </span>
    <span class="col-sm-4 col-4" (click)="navigateRaces(tomorrow)">
      {{ "HOME.TOMORROW" | translate }}
    </span>
  </div>
</div>
